import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'customerService' },
  { path: 'onlineOrder', loadChildren: () => import('src/app/modules/online-order/online-order.module').then(m => m.OnlineOrderModule) },
  { path: 'customerService', loadChildren: () => import('./modules/customer-service/customer-service.module').then(m => m.CustomerServiceModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
